import { styled, useTheme } from '@mui/material/styles';
import colors from '../../assets/colors';
import { Modal, Fade, Box } from '@mui/material';

const CustomModal = styled(Modal)({
  border: `1px solid ${colors.oldAgroweGreen}`,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  outline: 'none',
});

export default function StyledModal(props) {
  const theme = useTheme();
  return (
    <CustomModal open={props.open}>
      <Fade in={props.open}>
        <Box
          justifyContent="center"
          alignItems="center"
          sx={{
            position: 'relative',
            textAlign: 'center',
            backgroundColor: theme.palette.background.paper,
            border: `3px solid ${colors.oldAgroweGreen}`,
            borderRadius: 4,
            boxShadow: theme.shadows[5],
            padding: theme.spacing(2, 2, 3),
            outline: 'none',
          }}
        >
          {props.children}
        </Box>
      </Fade>
    </CustomModal>
  );
}
